const styles = {
  icon: {
    marginRight: 16,
    fontSize: 24,
  },
  editImageBtn: {
    position: "absolute",
    right: "5%",
    bottom: "10%",
  },
};

export default styles;
